import styled from "styled-components"

export default function AchievementSection({ children }) {
  return <Section>{children}</Section>
}

const Section = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #f7f7f7;
  padding-top: calc(100vw * (20 / 375));
  padding-right: calc(100vw * (17 / 375));
  padding-bottom: 0;
  padding-left: calc(100vw * (17 / 375));
`
